import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function TrustSection() {
  return <section className="w-full bg-bg-section py-12 md:py-20 px-4" data-id="element-322">
      <div className="max-w-4xl mx-auto" data-id="element-323">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-324">
          <div className="inline-flex items-center justify-center w-12 h-12 md:w-16 md:h-16 bg-accent-primary bg-opacity-10 rounded-full mb-4 md:mb-6" data-id="element-325">
            <ShieldCheckIcon className="h-6 w-6 md:h-8 md:w-8 text-accent-primary" aria-hidden="true" data-id="element-326" />
          </div>

          <h2 className="text-2xl md:text-4xl font-bold text-text-primary mb-4 md:mb-6" data-id="element-327">
            Arquitectura empresarial completa
          </h2>

          <p className="text-base md:text-lg text-text-secondary mb-6 md:mb-8 leading-relaxed max-w-3xl mx-auto" data-id="element-328">
            Este no es un curso genérico ni un hack fiscal. Es un sistema
            completo de arquitectura empresarial basado en los 4 pilares
            interdependientes que toda empresa estadounidense real necesita.
          </p>

          <p className="text-lg md:text-xl text-text-primary font-semibold mb-8 md:mb-12" data-id="element-329">
            El Ecosistema de los 4 Pilares te da la estructura, el orden y la
            legitimidad que necesitas para operar correctamente.
          </p>

          <div className="bg-bg-card border border-accent-primary border-opacity-20 rounded-lg p-4 md:p-6 max-w-2xl mx-auto" data-id="element-330">
            <p className="text-xs md:text-sm text-text-secondary leading-relaxed" data-id="element-331">
              <strong className="text-text-primary" data-id="element-332">Aviso legal:</strong> Este
              ebook es material educativo. No constituye asesoría legal, fiscal
              ni financiera. Consulta con profesionales licenciados para tu
              situación específica.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}